var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item,index){return _c('el-image',{key:index,staticStyle:{"width":"50px","margin":"0 3px 3px 0"},attrs:{"src":item,"preview-src-list":_vm.list}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }